<script lang="ts" setup>

  const questions = [
    {
      question: `Est-ce que je dois créer un compte pour réserver sur votre site internet ou sur vos applications ? `,
      answer:
        'Oui la création d\'un compte est obligatoire. Le golf doit pouvoir vous contacter facilement dans le cas où le parcours ne serait pas praticable pour différentes raisons ou tout autre évènement ne permettant pas de consommer votre green fee. ',
    },
    {
      question: `Je ne me souviens plus de mon mot de passe, comment faire ?`,
      answer:
        'Très simple, vous avez accès à la fonction "Mot de passe oublié ?" Au moment de votre connexion. Ainsi vous avez uniquement à renseigner l\'adresse email de votre compte Bookandgolf pour recevoir un mail de réinitialisation de mot de passe.',
    },
    {
      question: `Je n’arrive pas à annuler ma réservation, comment faire ?`,
      answer:
        'Sur Bookandgolf vous pouvez annuler jusqu\'à la dernière minute en fonction des conditions spéciales du golf que vous retrouvez dans votre confirmation d\'achat. Pour annuler, il faut vous connecter sur notre site ou applications puis rendez-vous dans Mes réservations pour annuler.',
    },
    {
      question: `J’ai annulé ma réservation mais je n’ai toujours pas de remboursement sur mon compte bancaire, est-ce normal ?`,
      answer:
        'Entre votre demande d\'annulation et votre remboursement, il peut se passer quelques jours lors desquels nous faisons le remboursement auprès de votre banque. Dès que nous avons fait le nécessaire, nous vous envoyons un mail. Le temps que vous soyez remboursé.e dépend ensuite de votre banque.',
    },
    {
      question: `J'ai effectué une demande de remboursement directement depuis le site internet, quel est le délais de remboursement ? `,
      answer:
        'Lorsque vous annuler votre réservation, vous recevez un mail pour confirmer que votre demande est bien en cours de traitement. Une fois votre demande traitée, nous vous envoyons un mail pour vous confirmer que le remboursement va se faire. La démarche peut prendre ensuite quelques jours selon votre banque.',
    },
    {
      question: `Je ne veux plus apparaître dans votre base client, comment faire ?`,
      answer:
        'Si vous ne souhaitez plus recevoir de mail commerciaux de notre part vous pouvez formuler votre demande directement sur l\'adresse email <a href="mailto:contact@bookandgolf.com">contact@bookandgolf.com</a> ou en cliquant sur "se désabonner" en bas de nos newsletters.',
    },
    {
      question: `Puis-je retirer un joueur de ma réservation de plusieurs joueurs ?`,
      answer:
        'Malheureusement il n\'est pas possible de retirer une personne d\'une réservation de plusieurs. Il vous faut annuler la réservation entière puis en faire à nouveau une avec le nombre de joueur souhaité.',
    },
    {
      question: `Comment bénéficier de mon code de réduction ?`,
      answer:
        'Si vous êtes en possession d\'un code de réduction vous pouvez le renseigner au moment de votre réservation dans l\'encart "Code promo". Attention, tous nos codes ont une date de validité.',
    },
    {
      question: `Dois-je présenter quelque chose au golf après ma réservation ?`,
      answer:
        'Oui, vous devez vous munir de votre confirmation d\'achat qui vous est envoyée par email au moment de votre réservation.',
    },
    {
      question: `Comment faire pour réserver un green fee sur Bookandgolf ?`,
      answer:
        'Il ne vous faut que quelques clics pour réserver. Dans un premier temps vous devez vous connecter avec vos identifiants, ou créer un compte le cas échéant, sur le support de votre choix. Ensuite sélectionner le golf sur lequel vous désirez jouer ainsi que la date de votre départ. Enfin, sélectionnez le créneau horaire que vous souhaitez en fonction des places disponibles. Pour finir, finalisez votre réservation en y ajoutant l\'ensemble des informations nécessaires. Lorsque votre réservation est enregistrée sur le planning du golf vous recevez un email de confirmation que vous devrez présenter à l\'accueil du golf lors de votre venue.',
    },
    {
      question: `Avez-vous une application ?`,
      answer:
        'Vous pouvez retourvez Bookandgolf directement sur l\'App Store ou sur Google Play Store en plus de notre site www.bookandgolf.com. ',
    },
  ]

  const router = useRouter()
  const route = useRoute()
  const { t } = useI18n()
  const { matches: matchDesktop } = useMatchMedia(ScreenWidth.desktop)

  function handleContactBtnClick() {
    router.push({ query: { ...route.query, modal: 'contact' } })
  }

</script>
<template>
  <div
    class="p-faq"
    :class="{'match-desktop': matchDesktop}"
  >
    <h1>
      <SvgIcon
        icon="help"
        :width="matchDesktop ? 38 : 20"
        :height="matchDesktop ? 38 : 20"
      />
      <span>Foire aux questions</span>
    </h1>
    <div class="content">
      <ExpansionPanel
        v-for="(question, index) in questions"
        :key="`question-${index}`"
      >
        <template #question>
          {{ question.question }}
        </template>
        <template #answer>
          <span v-html="question.answer" />
        </template>
      </ExpansionPanel>

      <p
        v-if="$config.public.isMobile"
        class="version"
      >
        Version : {{ $config.public.mobileVersion }}
      </p>

      <div class="footer">
        <ActionBlock
          :title="t('faq.action-block-title')"
          top-icon="contact"
          :centered="matchDesktop"
        >
          <Button
            class="button"
            type="primary"
            @click="handleContactBtnClick"
          >
            {{ t('faq.action-block-button') }}
          </Button>
        </ActionBlock>
      </div>
    </div>
  </div>
</template>
<style scoped>

.p-faq {
  display: flex;
  height: 100%;
  flex: 1 0 auto;
  flex-direction: column;
  background-color: white;

  h1 {
    display: flex;
    flex-direction: row;
    margin: 1.5em;

    .c-icon {
      margin-right: 0.875em;
      color: var(--color-primary);
    }

    span {
      color: var(--color-secondary);
      font-family: Open-Sans, sans-serif;
      font-size: 1.5em;
      font-weight: bold;
    }
  }

  .content {
    display: flex;
    overflow: hidden auto;
    flex-direction: column;
  }

  .version {
    padding-top: 1.5em;
    margin-top: 1.5em;
    color: var(--color-secondary);
    font-family: Open-Sans, sans-serif;
    font-size: 0.875em;
    font-weight: 500;
    opacity: 0.8;
    text-align: center;
  }

  .footer {
    position: relative;
    display: flex;
    overflow: visible;
    flex: 1 1 auto;
    justify-content: center;
    margin-top: 3em;

    .c-action-block {
      z-index: 2;
      flex: 1 1 auto;

      .c-button {
        margin-top: 2em;
        font-size: 1.5em;
        text-transform: uppercase;
      }

      .icon-link {
        display: flex;
        flex-direction: row;
        margin-top: 1rem;

        .phone-number {
          margin-left: 1em;
          color: var(--color-primary);
          font-family: Bariol, sans-serif;
          font-size: 1.5rem;
          font-weight: 600;

          .caption {
            margin-left: 0.625rem;
            color: var(--color-secondary);
            font-family: Open-Sans, sans-serif;
            font-size: 0.75Rem;
            font-weight: 400;
            opacity: 0.6;
          }
        }
      }
    }
  }

  @media screen and (width >= 1024px) {
    h1 {
      margin: 0 0 2.5em;

      span {
        font-size: 2.5em;
      }
    }

    .content {
      right: 0;
      left: 0;
      padding: 0 3em;
      overflow-y: scroll;
    }

    .footer {
      position: relative;
    }

    .footer::after {
      position: absolute;
      z-index: 1;
      background-color: var(--color-secondary-light);
      content: "";
      inset: 0 -6em;
    }
  }
}

</style>
